import React from 'react'
import { BasicCard } from '../../../components'

const ChartCard = ({title, legend, chart, className}) => {
  return (
    <BasicCard className={className}>
      <p className="lg:text-lg font-bold font-accent mb-5 uppercase">{title}</p>
      <div className="flex flex-wrap justify-between md:justify-start lg:justify-between">
        <div className="lg:w-1/2 md:mr-4 lg:mr-0">
          {legend}
        </div>
        <div className="lg:w-1/2 flex justify-end items-start">
          {chart}
        </div>
      </div>
    </BasicCard>
  )
}

export { ChartCard }